module.exports = __webpack_public_path__ + "img/receive.581b97cd.svg";